export default __webpack_public_path__ + "2be0a3755f1bc0106f3a280d8ef1c9c4.gif";